<script>
import {CONTEST_TYPE_BAKERY_MARATHON, CONTEST_TYPE_INDIVIDUAL} from '../../model/contest.js';
import { CONTEST_TYPE_CHAMPS       } from '../../model/contest.js';
import { CONTEST_TYPE_CLUBS        } from '../../model/contest.js';
import { CONTEST_TYPE_TEA          } from '../../model/contest.js';
import { CONTEST_TYPE_BUGZ         } from '../../model/contest.js';
import { CONTEST_TYPE_GVNT         } from '../../model/contest.js';
import { CONTEST_TYPE_RAINBOW_RUSH } from '../../model/contest.js';

import PlayerRating from './PlayerRating.vue';
import ContestTeaPlayerRating from './ContestTeaPlayerRating.vue';
import PlayerHistoryRating from './PlayerHistoryRating.vue';
import ClubRating from './ClubRating.vue';
import BakeryMarathonRating from "@/components/contest/BakeryMarathonRating.vue";

export default {
  name: 'RatingConcrete',

  props: {
    info: {
      type: Object,
      required: true,
    },
  },

  render(createElement) {
    const contestType = this.info.contestType;
    const componentType = getComponentType(contestType);
    const data = {
      props: {
        contestId: this.info.contestId,
        rating: this.info.rating,
      },
    };
    return createElement(componentType, data);
  },
};


/**
 * @param {number} contestType
 * @returns {Object}
 */
function getComponentType(contestType) {
  switch(contestType) {
    case CONTEST_TYPE_INDIVIDUAL:
      return PlayerRating;
    case CONTEST_TYPE_CHAMPS:
      return PlayerRating;

    case CONTEST_TYPE_CLUBS:
      return ClubRating;

    case CONTEST_TYPE_BAKERY_MARATHON:
      // return PlayerHistoryRating;
      return BakeryMarathonRating;

    case CONTEST_TYPE_TEA:
      return ContestTeaPlayerRating;

    case CONTEST_TYPE_BUGZ:
      return PlayerRating;
    case CONTEST_TYPE_GVNT:
      return PlayerRating;

    case CONTEST_TYPE_RAINBOW_RUSH:
      return PlayerHistoryRating;
  }
  return null;
}
</script>
